import type Owner from '@ember/owner';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { sortBy } from 'webapp/utils/common';

import BoardsPopupBoardToObjectBaseComponent from 'webapp/components/boards/popup-board-to-object-base';
import type { Args } from 'webapp/components/popup/inner/modal';

import type { TrackingOriginTypeForAddReport } from 'webapp/services/model-manager/boards';
import type ModelManagerReports from 'webapp/services/model-manager/reports';

export default class ReportsPopupBoardToReportComponent extends BoardsPopupBoardToObjectBaseComponent {
	@service('model-manager/reports') declare mmReportsService: ModelManagerReports;
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;

	override popupTargetObject = 'report';
	override popupIcon: IconName = 'Reports';

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.selectName = this.popupTargetObject.toLowerCase();
		this.selectPlaceholder = `Select ${this.popupTargetObject}`;

		void this.mmReportsService.requestReports().then(() => {
			this.selectedId = this.options[0]?.value || '';
		});
	}

	override get options() {
		const options = sortBy(this.mmReportsService.normalReportModels, 'id').map((item) => {
			const canCurrentUserEdit = item.canCurrentUserEdit,
				isDisabled = !canCurrentUserEdit || !item.slidesTypeBoardRemainingCount,
				slideCount = item.slideCount;

			return {
				value: item.id!,
				label: item.title,
				label2: `${slideCount} slide${slideCount === 1 ? '' : 's'}`,
				label3:
					(item.slidesTypeBoardRemainingCount
						? ''
						: '<span class="warn">Maximum dashboards added</span>') +
					this.getStatusIcon(canCurrentUserEdit, item.favorite),
				avatar: item.image || item.fallbackImage,
				bgTheme: item.bgTheme,
				color: item.color,
				disabled: isDisabled,
			};
		});

		return options;
	}

	override get actionOptions() {
		return [
			{
				id: null,
				text: 'New report',
				html: '<a class="loop-add">New report</a>',
				isSpecial: true,
				position: 'top',
				onClick: () => {
					const model = this.model;

					if (model) {
						this.mmReportsService.createFromBoards(
							model,
							this.popupData.trackingOrigin as TrackingOriginTypeForAddReport,
						);
					}
				},
			},
		];
	}
}
